import { Text } from '@comicrelief/component-library';
import { MoneybuyDescriptionWrapper } from './Moneybuys.style';
import { getCurrencySymbol } from '@/locale';
import { IndividualMoneybuy } from './types';
import { formatAmount } from '@/services/journeys/utils';

interface MoneybuyDescriptionProps {
  currencySymbol: string;
  isPayin: boolean;
  currentAmount: number;
  thisJourneysMoneybuys: IndividualMoneybuy[];
  currentMoneybuyPosition: number | null;
  hasError?: boolean;
}

function MoneybuyDescription({
  currencySymbol,
  isPayin,
  currentAmount,
  thisJourneysMoneybuys,
  currentMoneybuyPosition,
  hasError = false
}: MoneybuyDescriptionProps) {
  if (hasError) {
    return null;
  }

  // Keep a handy array of every amount for this journey type:
  const availableAmounts = thisJourneysMoneybuys?.map(item => item.amount);

  return (
    currentAmount && (
      <MoneybuyDescriptionWrapper data-test="moneybuyDescription">
        {isPayin ? (
          <>
            {thisJourneysMoneybuys.map(moneybuy => (
              <Text key={moneybuy.amount} tag="p" color="black">
                <Text tag="span" weight="bold" color="black">
                  {getCurrencySymbol()}
                  {moneybuy.amount}
                </Text>
                {moneybuy.description}
              </Text>
            ))}
          </>
        ) : (
          <Text tag="p" color="black">
            <Text tag="span" weight="bold" color="black">
              {currencySymbol}
              {formatAmount(currentAmount)}
            </Text>
            {/* Render the associated text, else use the generic fallback copy: */}
            {availableAmounts?.includes(currentAmount)
            && currentMoneybuyPosition !== null
              ? thisJourneysMoneybuys[currentMoneybuyPosition]?.description
              : 'will help us fund amazing projects in the UK and around the world.'}
          </Text>
        )}
      </MoneybuyDescriptionWrapper>
    )
  );
}

export default MoneybuyDescription;
